import { useContext } from "react"
import { DatabaseContext } from "./context"

export const useDb = () => {
    const { database } = useContext(DatabaseContext)
    return { db: database }
}
